import React, { useState, useMemo } from "react";

import "./index.scss";

import { loadLenguage } from "../../utilities";

const DynamicText = ({ text, isCapitalize = false }) => {
  const [word, setWord] = useState("");

  useMemo(() => {
    //get the lang
    const lenguagesJSON = loadLenguage();

    //cycle through the lang keys
    Object.keys(lenguagesJSON).map((leng) => {
      //if match with the session storage lang
      if (leng === sessionStorage.getItem("leng")) {
        //search into italian words, if match i use that index for find the word in the right language and set the word
        if (lenguagesJSON.it.indexOf(text.toLowerCase()) !== -1) {
          return setWord(
            lenguagesJSON[leng][lenguagesJSON.it.indexOf(text.toLowerCase())],
          );
        } else {
          //if the word doesn't exist return the same word
          return setWord(text);
        }
      }
      return null;
    });
  }, []);

  return (
    <React.Fragment>
      {isCapitalize ? (
        <>{word.substring(0, 1).toUpperCase() + word.substring(1)}</>
      ) : (
        word
      )}
    </React.Fragment>
  );
};

export default DynamicText;
